/* istanbul ignore file */
export interface TranslationsProp {
  durationMonths?: (count: number) => any;
  durationHours?: (count: number) => any;
  durationMinutes?: (count: number) => any;
}

const defaultTranslations: TranslationsProp = {
  durationMonths: (count: number) => (count === 1 ? '~ 1 month' : `~ ${count} months`),
  durationHours: (count: number) => (count === 1 ? '1 hour' : `${count} hours`),
  durationMinutes: (count: number) => (count === 1 ? '1 minute' : `${count} minutes`),
};

export default defaultTranslations;
